<template>
	<div class="error-page">
		<div class="error-page-content">
			<h2 v-html="title" />
			<p class="p1" v-html="description" />
			<a :href="ctaHref" class="button button--black">
				<span v-html="ctaText" />
			</a>
			<p class="p1" v-html="contactUs" />
		</div>
	</div>
</template>

<script>
/**
 * This displays when a page is not available. The component contains usable default prop values that can be overridden with content from CAAS if desired.
 */
export default {
	name: "ErrorPage",

	props: {
		/**
		 * Title text wrapped in an `h2` tag.
		 */
		title: {
			type: String,
			default: "This page is unavailable."
		},

		/**
		 * Description text wrapped in a `p` tag.
		 */
		description: {
			type: String,
			default:
				"The page you are looking for might have been removed or is temporarily unavailable."
		},

		/**
		 * Button url string.
		 */
		ctaHref: {
			type: String,
			default: "/"
		},

		/**
		 * Button text string.
		 */
		ctaText: {
			type: String,
			default: "Return home"
		},

		/**
		 * HTML text string for the content below the button.
		 */
		contactUs: {
			type: String,
			default:
				'If the problem persists, <a class="error-page-contact-us" href="/contact-us" rel="noopener noreferrer" target="_blank">contact us</a>.'
		}
	}
};
</script>

<style scoped lang="scss">
// adding excess weight to selectors to override any app css
body div.error-page {
	width: 100%;
	.error-page-content {
		margin: 0 auto;
		padding: 36px 0;
		text-align: center;

		@include from-md() {
			padding: 96px 0;
			max-width: 500px;
		}

		h2,
		p,
		a {
			margin-top: 24px;
		}

		p {
			margin-bottom: 0;

			::v-deep a {
				color: $color--red-3;
				font-weight: 600;
				text-decoration: underline;

				&:hover {
					color: $color--red-3;
					font-weight: 600;
					text-decoration: underline;
				}
			}
		}

		.button {
			padding: 18px 24px 14px;
		}
	}
}
</style>
